import $ from 'jquery'
import PriseConstante from '@/views/consultations/prendre-constante'

export default {
  name: 'salle-attente',
  components: {
    PriseConstante
  },
  props: [],
  data () {
    return {
      fields: [{ key: 'index', label: 'N°' },{key:'noms_prenoms',label:'Nom et prénoms'} ,'sexe', 'contact','Assurance','Consultation','actions'],
      filter: "",
      tableIsBusy:  true,
      perPage: 10,
      currentPage: 1,
      selectedConsultation: null

    }
  },
  computed: {
     consultationsEnAttente(){
        return this.$store.getters['consultationsEnAttente'];
     }
  },
  mounted () {
    setTimeout(() => {
      $('.shw').fadeIn()
    }, 500);
    this.$store.dispatch('getConsultationsEnAttente').then(()=>{
      this.tableIsBusy =false;
     
    });
  },
  methods: {
     changeSelectedConsultation: function(consultation){
       this.selectedConsultation = consultation
     }

  }
}


